<template>
  <section class="table-comparative-previous-tournaments">
    <div class="table-comparative-previous-tournaments__row-header">
      <div class="table-comparative-previous-tournaments__row-header__col">Torneos</div>
      <div class="table-comparative-previous-tournaments__row-header__col">
        <div class="table-comparative-previous-tournaments__row-header__col__text">Meta</div>
      </div>
      <div class="table-comparative-previous-tournaments__row-header__col">
        <div class="table-comparative-previous-tournaments__row-header__col__text">Banda</div>
      </div>
      <div class="table-comparative-previous-tournaments__row-header__col">
        <div class="table-comparative-previous-tournaments__row-header__col__text">Esquina</div>
      </div>
      <div class="table-comparative-previous-tournaments__row-header__col">
        <div class="table-comparative-previous-tournaments__row-header__col__text">Falta</div>
      </div>
    </div>

    <template v-for="(dataItem, indexPage) in data">
      <div
        :key="indexPage"
        class="table-comparative-previous-tournaments__row "
        :class="{ 'row-margin': indexPage == 0 }"
      >
        <div
          class="table-comparative-previous-tournaments__row__col "
          :class="{ 'border-top-left-right': indexPage == 0, 'border-bottom-left-right': indexPage == data.length - 1 }"
        >
          <div class="text-pc">{{ dataItem.season }}</div>
          <div class="text-movil">{{ dataItem.seasonShort }}</div>
        </div>
        <div
          class="table-comparative-previous-tournaments__row__col color-gray"
          :class="{ 'border-top-left': indexPage == 0, 'border-bottom-left': indexPage == data.length - 1 }"
        >
          <template v-if="type == 0">{{ dataItem.metatime }}</template>
          <template v-else>{{ dataItem.metaevent }}</template>
        </div>
        <div class="table-comparative-previous-tournaments__row__col color-gray">
          <template v-if="type == 0">{{ dataItem.bandatime }}</template>
          <template v-else>{{ dataItem.bandaevent }}</template>
        </div>
        <div class="table-comparative-previous-tournaments__row__col color-gray">
          <template v-if="type == 0">{{ dataItem.esquinatime }}</template>
          <template v-else>{{ dataItem.esquinaevent }}</template>
        </div>
        <div
          class="table-comparative-previous-tournaments__row__col color-gray "
          :class="{ 'border-top-right': indexPage == 0, 'border-bottom-right': indexPage == data.length - 1 }"
        >
          <template v-if="type == 0">{{ dataItem.faltatime }}</template>
          <template v-else>{{ dataItem.faltaevent }}</template>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'TableComparativePreviousTournaments',
  components: {},
  computed: {},
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.border-top-right {
  border-top-right-radius: 4px;
}
.border-bottom-right {
  border-bottom-right-radius: 4px;
}
.border-top-left {
  border-top-left-radius: 4px;
}
.border-bottom-left {
  border-bottom-left-radius: 4px;
}
.border-top-left-right {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.border-bottom-left-right {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.text-pc {
  @media screen and (max-width: 500px) {
    display: none;
  }
}
.text-movil {
  display: none;
  @media screen and (max-width: 500px) {
    display: inline-block;
  }
}
.row-margin {
  margin-top: 2px;
}
.color-gray {
  background: #f8fafc !important;
}
.color-white {
  background: #ffffff !important;
}
.table-comparative-previous-tournaments {
  width: 96.8%;
  margin-left: 1.6%;
  margin-top: 7px;
  height: 210px;
  &__row-header {
    width: 100%;
    height: 52px;
    display: inline-flex;
    &__col:first-child {
      width: 27.24%;
      height: 52px;
      border-radius: 4px;
      background-color: #132739;
      font-size: 13px;
      border-right: solid 1px #132739;
      border-left: solid 1px #132739;
      font-weight: normal;
      font-stretch: normal;
      margin-right: 0.66%;
      margin-left: 0px !important;
      font-style: normal;
      line-height: 52px;
      letter-spacing: -0.26px;
      text-align: center;
      font-family: 'Avenir-Demi';
      color: #fff;
    }
    &__col {
      width: 18.07%;
      height: 52px;
      background-color: #52a0fc;
      border-right: solid 1px #ffffff;
      border-left: solid 1px #ffffff;

      font-family: 'Avenir-Demi';
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 52px;
      letter-spacing: -0.28px;
      text-align: center;
      color: #fff;
      @media screen and (max-width: 500px) {
        font-size: 13px;
      }
      @media screen and (max-width: 380px) {
        font-size: 12px;
      }
      @media screen and (max-width: 340px) {
        font-size: 11px;
      }
    }
    &__col:nth-child(2) {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-left: 1px solid #52a0fc;
    }
    &__col:nth-child(5) {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-right: 1px solid #52a0fc;
    }
  }
  &__row {
    width: 100%;
    height: 40px;
    display: inline-flex;
    &__col:first-child {
      width: 27.24%;
      height: 40px;
      background-color: #132739;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      border: solid 1px #224361 !important;
      margin-right: 0.66%;
      margin-left: 0px !important;
      font-style: normal;
      line-height: 40px;
      letter-spacing: -0.26px;
      text-align: center;
      font-family: 'Avenir-Demi';
      color: #fff;
      @media screen and (max-width: 600px) {
        padding-right: 0px;
        text-align: center;
      }
    }
    &__col {
      width: 18.07%;
      height: 40px;
      border: solid 1px #ecedef;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 40px;
      font-family: 'Avenir-Bold';
      letter-spacing: -0.28px;
      text-align: center;
      color: #132839;
    }
  }
}
</style>
